module.exports = __webpack_public_path__ + "static/img/yytx04.2bdcbb3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx04.png
// module id = 876
// module chunks = 0